import React from 'react'
import AuthUserContext from './auth-user-context'
import { firebase } from '../firebase'

const withAuthentication = (Component) => {
	return (
		class WithAuthentication extends React.Component {
			constructor(props) {
				super(props)

				this.state = {
					authUser: null,
				}
			}

			// The question is: "Is there a currently signed in user?"
			// There is no logic yet about an authenticated user.
			// The information needs to be stored somewhere
			// to make it accessible to other components

			// Often that’s the point where people start to use a state management
			// library such as Redux or MobX. But since our whole application is
			// grouped under the umbrella App component, it’s sufficient to manage the
			// session state in the App component by using React’s local state.
			// It only needs to keep track of an authenticated user.
			componentDidMount() {
				firebase.auth.onAuthStateChanged((authUser) => {
					if (authUser) {
						this.setState({
							authUser: authUser,
						})
					} else {
						this.setState({
							authUser: null,
						})
					}
				})
			}

			render() {
				const {
					authUser
				} = this.state

				return (
					<AuthUserContext.Provider value={authUser}>
						<Component />
					</AuthUserContext.Provider>
				)
			}
		}
	)
}

export default withAuthentication


// WEBPACK FOOTER //
// ./src/common/components/with-authentication.js